export default "__VITE_ASSET__CY5luDU1__";